import { get, post } from './http'

//1.获取已购项目
export const httpBoughtItemInfoGet = params => post('api/Order/getresumeorderdetail/' + params);

//2.获取用户基本信息及文件信息
export const httpBuyerInfoGet = params => post('api/Order/getorderuserinfo/' + params);

//3.原始简历上传
export const httpResumeUploadOriginal = params => post('api/OrderUserResume/uploadresumebase64', params);

//4.导出优化的简历
export const httpResumeExport = params => post('api/OrderResume/orderhasresume/' + params);

//导出职业生涯
export const httpCareerPlanExport = params => post('api/OrderCareePlan/orderhascareerplan/' + params);

//5.交付简历
export const httpResumeDelivery = params => post('api/OrderResume/deliverresume', params);

//6.交付职业生涯规划
export const httpCareerPlanDelivery = params => post('api/OrderCareePlan/deliverplan', params);

//7.获取职业生涯规划
export const httpCareerPlanGet = params => post('api/OrderCareePlan/getcareerplan/' + params);

//8.新增职业生涯规划
export const httpCareerPlanAdd = params => post('api/OrderCareePlan/addcareerplan', params);

//9.编辑职业生涯规划
export const httpCareerPlanEdit = params => post('api/OrderCareePlan/updatecareerplan', params);

//10.判断简历是否可以交付
export const httpResumeDeliveryCheck = params => post('api/OrderResume/candeliverresume/' + params);

//11.获取面试辅导
export const httpInterviewGet = params => get('api/InterviewCoach/getinterviewcoach/' + params);

//12.新增面试辅导
export const httpInterviewAdd = params => post('api/InterviewCoach/addinterviewcoach', params);

//13.编辑面试辅导
export const httpInterviewEdit = params => post('api/InterviewCoach/updateinterviewcoach', params);

//14.判断面试辅导是否可以交付
export const httpInterviewDeliveryCheck = params => get('api/InterviewCoach/orderhasinterviewcoach/' + params);

//15.面试辅导导出
export const httpInterviewExport = params => get('api/InterviewCoach/dowloadinterviewcoach', params);

//16.面试辅导交付
export const httpInterviewDelivery = params => post('api/InterviewCoach/deliverinterviewcoach', params);


// WEBPACK FOOTER //
// ./src/api/orderDetails.js